const NotFoundPage = () => {
  return (
    <div className='notFound w-full flex flex-col justify-start items-center pt-[20%] gap-[30px]'>
      <img
        src='/imgs/icons/symbol.webp'
        alt='한국영업경제인협회 심볼'
        className='w-[120px] object-contain'
      />
      <p className='text-[40px] leading-[60px]'>페이지를 찾을 수 없습니다.</p>
    </div>
  );
};
export default NotFoundPage;
